export const blockIconsHomeWeatherSnowyNew = (
	<span className='material-symbols-outlined'>weather_snowy</span>
);
